module.exports = __webpack_public_path__ + "img/total-keywords.21871e4f.svg";